
export class PhoneNumber {
  constructor(public id?: number,
    public connectionId?: number,
    public phone?: string,
    public name?: string,
    public nameEng?: string,
    public nameIta?: string,
    public nameSr?: string,
    public nameBs?: string,
    public nameSlo?: string) {
  }
}
